import { get } from 'lodash';
import * as LaunchpadConstants from 'constants/launchpad';

// Pulled in from launchpad-spa src/components/ConnectBanner/ConnectBanner.tsx
export const getEnvironment = () => {
  const url = window.location.host;

  if (url.includes('.nextos.')) {
    return 'production';
  }

  if (url.includes('.rc.')) {
    return 'rc';
  }

  return 'dev';
};

// Pulled in from launchpad-spa src/components/ConnectBanner/ConnectBanner.tsx
export const downloadDesktopApp = () => {
  const platform =
    (navigator as any).userAgentData?.platform || navigator?.platform;

  const isMac = platform.toLowerCase().includes('mac');
  const isLinux = platform.toLowerCase().includes('linux');

  if (isMac) {
    window.location.href =
      LaunchpadConstants.MAC_DOWNLOAD_DESKTOP_LINKS[getEnvironment()];
    return;
  } else if (isLinux) {
    window.location.href =
      LaunchpadConstants.LINUX_DOWNLOAD_DESKTOP_LINKS[getEnvironment()];
    return;
  }

  window.location.href =
    LaunchpadConstants.WINDOWS_DOWNLOAD_DESKTOP_LINKS[getEnvironment()];
};

export const navigateToLicenses = () => {
  window.location.assign(
    `${window.location.origin}/apps/platform-admin/#/licensing/licenses`,
  );
};

export const navigateToConnect = () => {
  window.location.assign(`${window.location.origin}/apps/nextiva-connect`);
};

// Pulled in from launchpad-spa src/views/tabs/HomeTab/HomeTab.tsx
export const voiceAdminDisabledDueToBwPatchingChecker = ({
  isClusterIdInBWPatching,
  isAdminAndVoiceUser,
  isVoiceAccount,
  userPrimaryIdentifier,
}) =>
  Boolean(
    isClusterIdInBWPatching &&
      (isAdminAndVoiceUser || (isVoiceAccount && userPrimaryIdentifier)),
  );

export const validatePermission = (
  resourceId: string,
  permissions = [],
  permissionName: string,
  userRoleIsSuperAdmin: boolean,
): boolean => {
  if (userRoleIsSuperAdmin) return true;

  if (!permissions?.length) {
    return false;
  }
  const permission = permissions.find((p) => p.resource_id === resourceId);

  return get(permission, `value.${permissionName}`, false) as boolean;
};

export const userIsSuperAdmin = (roles = []) => {
  const isSuperAdmin = roles?.some(
    (element) => element.roleType === LaunchpadConstants.SUPER_ADMIN_ROLE_TYPE,
  );

  return isSuperAdmin;
};
